import { ServiceProductItem, ServiceProductDetail } from 'model/modules/services/serviceProductItem';
import { ApiServiceProductItem, ApiServiceProductDetail } from 'rtkQuery/sharespro/types/services/serviceProductItem';

export const mapServiceProductItemFromApi = (api: ApiServiceProductItem): ServiceProductItem => ({
  id: api.id,
  coverImageUrl: api.cover_image_url ?? '',
  title: api.title,
  subtitle: api.subtitle ?? '',
  subtitle2: api.subtitle2 ?? '',
  primaryColor: api.primary_color ?? '',
  contentAction: api.content_action,
});

export const mapServiceProductListFromApi = (items: ApiServiceProductItem[]): ServiceProductItem[] =>
  items.map(mapServiceProductItemFromApi);

export const mapServiceProductDetailFromApi = (api: ApiServiceProductDetail): ServiceProductDetail => ({
  ...mapServiceProductItemFromApi(api),
  detailImageUrl: api.detail_image_url,
  content: api.content,
});
